import {isNullOrUndefined} from '../util/js-util';
import {Field} from '../domain/Field';

export function trackByField(index, field: Field): string {
  let retval;
  if (!isNullOrUndefined(field.unitOfMeasureField)) {
    retval = field.id + ':::' + field.unitOfMeasureField.choices.find(c => c.selected).id;
  } else if (field.displayType !== 'MULTIPICK' && !isNullOrUndefined(field.choices)) {
    const selected = field.choices.find(c => c.selected);
    if (!isNullOrUndefined(selected)) {
      retval = field.id + ':::' + selected.id;
    } else {
      retval = field.id;
    }
  } else {
    retval = field ? field.id : undefined;
  }
  return field.updates + retval;
}

export function trackById(index, object): string {
  return object ? object.id : undefined;
}
